import { Grid } from "@material-ui/core";
import React from "react";
import { Control } from "react-hook-form";
import { CustomText } from "../../../components/index";
import { fonts } from "../../../config";
import { validations } from "../../../utils";
import Styles from "../styles";
import {
  Input,
  InputPhone,
  InputDate,
} from "../../../components/inputs/newForm";

export function DrawMembers(number: number, control: Control<any>) {
  const membersForm: any = [];

  for (let index = 0; index < number; index++) {
    membersForm.push(
      <React.Fragment key={index}>
        <Styles.Barra />
        <CustomText
          fontFamily={fonts.bold}
          fontSize={14 / 8}
          textColor="#272727"
          style={{ paddingTop: "12px", paddingBottom: "4px" }}
        >
          ACOMPANHANTE #{index + 1}
        </CustomText>
        <Grid alignItems="flex-end" container spacing={1}>
          <Grid item xs={12} md={12} lg={3}>
            <Input
              control={control}
              name={"fullName" + (index + 1)}
              label="Nome Completo"
            />
          </Grid>
          <Grid item xs={12} md={12} lg={3}>
            <Input
              control={control}
              name={"email" + (index + 1)}
              label="E-Mail"
            />
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <InputPhone
              control={control}
              placeholder="99 99999-9999"
              label="Telefone"
              name={"phone" + (index + 1)}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <InputDate
              control={control}
              maxDate={new Date()}
              name={"birthday" + (index + 1)}
              label="DATA NASCIMENTO"
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
  return membersForm;
}
